export const topbrokerholdingbydurationTypes = {
    VIEW_TOP_BROKER_HOLDING_BY_DURATION: 'VIEW_TOP_BROKER_HOLDING_BY_DURATION',
    VIEW_TOP_BROKER_HOLDING_BY_DURATION_ERROR: 'VIEW_TOP_BROKER_HOLDING_BY_DURATION_ERROR',
    VIEW_TOP_BROKER_CODE_HOLDING_BY_DURATION: 'VIEW_TOP_BROKER_CODE_HOLDING_BY_DURATION',
    VIEW_TOP_BROKER_CODE_HOLDING_BY_DURATION_ERROR: 'VIEW_TOP_BROKER_CODE_HOLDING_BY_DURATION_ERROR',
    VIEW_TOP_BROKER_SECTORNAME_HOLDING_BY_DURATION: 'VIEW_TOP_BROKER_SECTORNAME_HOLDING_BY_DURATION',
    VIEW_TOP_BROKER_SECTORNAME_HOLDING_BY_DURATION_ERROR: 'VIEW_TOP_BROKER_SECTORNAME_HOLDING_BY_DURATION_ERROR',
};
